import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from '@reach/router';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { ApolloProvider } from '@apollo/react-hooks';
import ApolloClient from 'apollo-boost';
import fetch from 'unfetch';
import _JSXStyle from 'styled-jsx/style';
import * as serviceWorker from './serviceWorker';
import App from './App';
import {
  AuthComponent,
  ListCoursesComponent,
  NewCourseComponent,
  SessionExpiredComponent,
} from './pages';

if (typeof global !== 'undefined') {
  Object.assign(global, { _JSXStyle });
}

const client = new ApolloClient({
  fetch,
  fetchOptions: {
    credentials: 'include',
  },
  uri: `${process.env.REACT_APP_SHOPIFIC_GATEWAY_URI}/api/graphql`,
  request: async (operation) => {
    operation.setContext({});
  },
});

const initializeFlagProvider = async () => {
  return asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_ID,
  });
};

const renderApp = async () => {
  const FlagProvider = await initializeFlagProvider();

  ReactDOM.render(
    <FlagProvider>
      <ApolloProvider client={client}>
        <Router>
          <App path="/">
            <AuthComponent path="/auth/*" />
            <ListCoursesComponent path="/home" />
            <NewCourseComponent path="/newcourse" />
            <SessionExpiredComponent path="/sessionexpired" />
          </App>
        </Router>
      </ApolloProvider>
    </FlagProvider>,
    document.getElementById('root')
  );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

renderApp();

if (module.hot) {
  module.hot.accept();
}
